// extracted by mini-css-extract-plugin
export var actionButton = "_kc-t";
export var buttonContainer = "_kc-0";
export var buttonContainer2 = "_kc-1";
export var buttonSection = "_kc-2";
export var details = "_kc-3";
export var dropdownItem = "_kc-5";
export var dropdownItemsContainer = "_kc-4";
export var fileInput = "_kc-r";
export var headerButton = "_kc-6";
export var icon = "_kc-7";
export var input = "_kc-8";
export var macroListItem = "_kc-9";
export var mainContent = "_kc-a";
export var microText = "_kc-b";
export var modal = "_kc-w";
export var optionsButton = "_kc-c";
export var paperclip = "_kc-s";
export var pillContent = "_kc-d";
export var preview = "_kc-e";
export var preview2 = "_kc-f";
export var quillEditor = "_kc-q";
export var selectedMacro = "_kc-g";
export var sidebar = "_kc-h";
export var sidebarHeader = "_kc-j";
export var sidebarList = "_kc-i";
export var sidebarListItem = "_kc-k";
export var sidebarSearch = "_kc-l";
export var snoozeDurationWrapper = "_kc-v";
export var statusPillContainer = "_kc-m";
export var tagsContainer = "_kc-n";
export var unselectedMacro = "_kc-o";
export var variable = "_kc-u";
export var wrapper = "_kc-p";